import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { X, Languages } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const DISMISS_KEY = "dr_lang_banner_dismissed";

// Site otomatik olarak İngilizce açıldığında gösterilen küçük karşılama şeridi.
export default function LanguageBanner() {
  const { lang, setLang, autoDetected } = useLang();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (autoDetected && lang === "en" && !localStorage.getItem(DISMISS_KEY)) {
      const timer = setTimeout(() => setVisible(true), 900);
      return () => clearTimeout(timer);
    }
    setVisible(false);
  }, [autoDetected, lang]);

  const close = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setVisible(false);
  };

  const switchToTr = () => {
    localStorage.setItem(DISMISS_KEY, "1");
    setLang("tr");
    setVisible(false);
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 16 }}
          transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
          data-testid="language-welcome-banner"
          className="fixed bottom-4 left-1/2 z-[70] w-[calc(100%-2rem)] max-w-xl -translate-x-1/2"
        >
          <div className="flex flex-col gap-3 rounded-2xl border border-white/10 bg-[#07111F]/95 px-5 py-4 text-white shadow-2xl shadow-black/40 backdrop-blur-xl sm:flex-row sm:items-center sm:gap-4">
            <span className="inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#2563EB]/40 to-[#22D3EE]/30 border border-white/10">
              <Languages className="h-4 w-4 text-[#22D3EE]" />
            </span>
            <p className="flex-1 text-sm leading-snug text-white/80">
              We opened this site in English for you.{" "}
              <span className="font-semibold text-white">Türkçe okumak ister misiniz?</span>
            </p>
            <div className="flex items-center gap-2">
              <button
                type="button"
                onClick={switchToTr}
                data-testid="language-banner-tr"
                className="whitespace-nowrap rounded-xl bg-gradient-to-r from-[#2563EB] to-[#22D3EE] px-4 py-2 text-sm font-semibold text-white transition hover:-translate-y-0.5"
              >
                Türkçe devam et
              </button>
              <button
                type="button"
                onClick={close}
                aria-label="Close"
                data-testid="language-banner-close"
                className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-white/15 text-white/60 transition hover:bg-white/10 hover:text-white"
              >
                <X className="h-4 w-4" />
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
